import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CreditCard, Sparkle } from '@phosphor-icons/react';

// Billing & plans placeholder — full Razorpay integration arrives in Sprint B.
export default function BillingPage() {
  const { activeWorkspace, activePlan } = useAuth();
  const inr = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;
  return (
    <div className="max-w-3xl mx-auto space-y-4">
      <h1 className="text-2xl font-bold" style={{ color: '#1a2e4a' }}>Billing &amp; Plans</h1>
      <Card className="p-5">
        <div className="flex items-center gap-3 mb-2">
          <CreditCard size={22} weight="duotone" className="text-blue-600" />
          <div>
            <div className="text-xs uppercase tracking-wider text-gray-500">Current workspace</div>
            <div className="font-bold text-lg" style={{ color: '#1a2e4a' }}>{activeWorkspace?.name || '—'}</div>
          </div>
        </div>
        <div className="grid sm:grid-cols-3 gap-3 mt-4 text-sm">
          <div className="border rounded p-3 bg-slate-50">
            <div className="text-[10px] uppercase tracking-wider text-gray-500">Plan</div>
            <div className="font-bold" style={{ color: '#1a2e4a' }}>{activePlan?.name || activeWorkspace?.plan_code || 'Free'}</div>
          </div>
          <div className="border rounded p-3 bg-slate-50">
            <div className="text-[10px] uppercase tracking-wider text-gray-500">Status</div>
            <div className="font-bold capitalize" style={{ color: '#1a2e4a' }}>{activeWorkspace?.status || 'active'}</div>
          </div>
          <div className="border rounded p-3 bg-slate-50">
            <div className="text-[10px] uppercase tracking-wider text-gray-500">Annual price</div>
            <div className="font-bold" style={{ color: '#1a2e4a' }}>{inr(activePlan?.price_inr)}</div>
          </div>
        </div>
      </Card>

      <Card className="p-5 border-2 border-amber-200 bg-amber-50">
        <div className="flex items-start gap-3">
          <Sparkle size={20} weight="fill" className="text-amber-500 mt-0.5" />
          <div className="flex-1">
            <div className="font-bold text-amber-900">Razorpay billing — coming in Sprint B</div>
            <p className="text-sm text-amber-800 mt-1">
              Subscription auto-debit, plan upgrades, invoice receipts, and dunning emails
              will be wired up once you share your Razorpay Test Key ID + Secret + Webhook
              Secret. For now, all workspaces stay active without payment.
            </p>
            <Button className="mt-3" size="sm" variant="outline" onClick={() => window.open('https://razorpay.com/sign-up/', '_blank')}>
              Sign up at Razorpay →
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
